import React, { useState, FC } from "react";

import { splConstants } from "@malloc-protocol/spl";
import { useStore } from "react-stores";
import { globalStore } from "../globalStore";
import { fontFamily } from "@mui/system";

const NodeSelector: FC = () => {
  const state = useStore(globalStore);

  const dispActionUID = (uid: string): string => {
    if (uid === "RAYDIUM_LP_STAKE") return "RAYDIUM_LP_FARM";
    else return uid;
  };

  return (
    <div>
      <select
        className="form-select"
        aria-label="Default select example"
        onChange={(e) => {
          state.context.selectedActionType = parseInt(e.target.value);
          globalStore.setState({ ...state });
        }}
      >
        {Object.keys(splConstants.BUILD_ACTION_UIDS).map((action, index) => {
          return <option value={index}>{dispActionUID(action)}</option>;
        })}
      </select>
      <span className="fine-print">
        double click to create a new{" "}
        {dispActionUID(
          Object.keys(splConstants.BUILD_ACTION_UIDS)[
            state.context.selectedActionType
          ]
        )}{" "}
        action
      </span>
    </div>
  );
};

export default NodeSelector;
